var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 247,
    viewBox: "0 0 308 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4512 40.5215C15.0322 39.1075 29.6572 28.2505 29.6572 28.2505L275.736 13.7046L247.008 229.268L20.1292 226.507L13.4512 40.5215Z",
    stroke: "#E62D2E",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5232 70.2057C35.9672 69.0998 49.3232 60.5993 49.3232 60.5993L274.068 49.2126L247.83 217.962L40.6204 215.8L34.5232 70.2057Z",
    fill: "white",
    stroke: "#E5EAED",
    strokeWidth: 35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.646 40.8673L284.783 35.7302L288.497 39.4439L283.36 44.581L289.166 50.3871L285.253 54.3002L279.447 48.4942L274.295 53.6454L270.582 49.9317L275.733 44.7804L270.169 39.2162L274.082 35.3031L279.646 40.8673Z",
    fill: "url(#paint0_linear_6_492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6201 62.0374C26.2001 60.7844 40.8203 51.1643 40.8203 51.1643L286.762 38.2756L258.05 229.266L31.2971 226.822L24.6201 62.0374Z",
    stroke: "#B7232B",
    strokeWidth: 35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.603 38.502L288.647 34.4573L291.571 37.3812L287.527 41.4259L292.097 45.9966L289.017 49.0775L284.446 44.5067L280.391 48.562L277.467 45.6381L281.522 41.5828L277.141 37.2023L280.222 34.1214L284.603 38.502Z",
    fill: "url(#paint1_linear_6_492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6021 106.343V133.355L82.6641 145.095H100.611V158.071L103.471 159.525H113.815L115.629 158.071V105.307H102.419L101.308 106.343V130.405H88.7209L84.8101 127.096V105.306H71.51L70.6021 106.343Z",
    fill: "url(#paint2_linear_6_492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.869 159.252H126.961L123.786 154.954V108.366L126.961 105.308H166.869L169.806 108.366V154.954L166.87 159.254L166.869 159.252ZM139.602 117.021L137.675 120.367V142.908L139.602 145.817H152.734L154.698 143.06V119.808L152.734 117.022L139.602 117.021Z",
    fill: "url(#paint3_linear_6_492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.966 106.343V133.355L190.028 145.095H207.975V158.071L210.835 159.525H221.179L222.993 158.071V105.307H209.783L208.672 106.343V130.405H196.085L192.174 127.096V105.306H178.874L177.966 106.343Z",
    fill: "url(#paint4_linear_6_492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.512 131.234C142.634 131.234 143.543 130.057 143.543 128.606C143.543 127.154 142.634 125.978 141.512 125.978C140.39 125.978 139.481 127.154 139.481 128.606C139.481 130.057 140.39 131.234 141.512 131.234Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.563 131.295C151.685 131.295 152.594 130.118 152.594 128.667C152.594 127.215 151.685 126.039 150.563 126.039C149.441 126.039 148.532 127.215 148.532 128.667C148.532 130.118 149.441 131.295 150.563 131.295Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.009 136.431C150.009 137.618 148.351 136.431 146.309 136.431C144.267 136.431 142.609 137.618 142.609 136.431C142.609 135.402 143.853 134.542 145.514 134.331C145.779 134.296 146.047 134.279 146.314 134.28C146.761 134.278 147.207 134.326 147.644 134.423C149.023 134.734 150.009 135.516 150.009 136.431Z",
    fill: "#2F2E41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_492",
    x1: 305.749,
    y1: 69.2215,
    x2: 270.215,
    y2: 35.1614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAAAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_492",
    x1: 305.153,
    y1: 60.8241,
    x2: 277.178,
    y2: 34.0097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAAAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_492",
    x1: 93.1156,
    y1: 105.306,
    x2: 93.1156,
    y2: 159.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAAAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED2024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_492",
    x1: 146.796,
    y1: 105.308,
    x2: 146.796,
    y2: 159.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAAAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED2024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_492",
    x1: 200.48,
    y1: 105.306,
    x2: 200.48,
    y2: 159.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAAAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED2024"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 306.502,
    height: 246.598,
    fill: "white",
    transform: "translate(0.749023 0.331543)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.5fefb772cba99f4017676bef5697a867.svg";
export { ForwardRef as ReactComponent };